import { Divider } from '@mui/material';

export default function Hr() {
  return <Divider sx={{ my: 2 }} />;
}
